<template>
  <div :class="['rating-wrapper', classParam ? classParam : '']">
    <div class="rating-stars">
      <div
        class="full-star"
        v-for="n in Math.floor(rating)"
        :key="n + '-f-star'"
      ></div>
      <div class="full-star" v-if="rating % 1 >= 0.5"><span></span></div>
      <div
        class="full-star clear"
        v-for="k in 5 - ratioMath"
        :key="k + '-no-star'"
      ></div>
      <!-- <img
        v-for="n in Math.floor(rating)"
        :key="n + '-f-star'"
        :src="$root.site_url + $root.asset_path + '/svg-icons/full-star.svg'"
        alt="Full Star Icon"
      />
      <img
        v-if="rating % 1 >= 0.5"
        :src="$root.site_url + $root.asset_path + '/svg-icons/half-star.svg'"
        alt="Half Star Icon"
      />
      <img
        v-for="k in 5 - ratioMath"
        :key="k + '-no-star'"
        :src="$root.site_url + $root.asset_path + '/svg-icons/no-star.svg'"
        alt="Blank Star Icon"
      /> -->
    </div>
    <div class="rating-star-total" v-if="!noText">
      <span>{{ rating }}</span> / 5
    </div>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  props: {
    rating: Number,
    noText: Boolean,
    classParam: String,
  },
  computed: {
    ratioMath: function () {
      if (this.rating >= 4 && this.rating < 4.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 3 && this.rating < 3.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 2 && this.rating < 2.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 1 && this.rating < 1.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 0 && this.rating < 0.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 4.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 3.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 2.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 1.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 0.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else {
        return Math.ceil(this.rating);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.rating-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.rating-stars {
  display: flex;
  position: relative;
  unicode-bidi: bidi-override;
  direction: ltr;
  counter-reset: star-rating;
  font-size: 0;
  margin-left: 0;
  margin-right: 0;
  padding-right: 7px;
  img {
    width: 14px;
    height: auto;
    margin-right: 4px;
    border-radius: 2px;
    margin-bottom: 0px !important;
    cursor: default;
  }
}

.rating-star-total {
  pointer-events: none;
  direction: ltr;
  unicode-bidi: bidi-override;
  position: relative;
  right: -2px;
  top: 1px;
  color: #222222;
  font-size: 16px;
  span {
    font-size: 16px;
    font-weight: bold;
    font-family: var(--default-bold);
  }
}
.casino-list-ratings {
  align-items: start;
  flex-direction: column;
  justify-content: flex-start;
  @media (min-width: @sizes[extra-small]) {
    align-items: center;
    flex-direction: row;
  }
}

.full-star {
  width: 14px;
  height: 14px;
  background: #fabf00;
  border-radius: 2px;
  margin-right: 3px;
  position: relative;
  span {
    position: absolute;
    height: 100%;
    width: 50%;
    top: 0;
    left: 50%;
    background: #e5e5e5;
  }
  &.clear {
    background: #e5e5e5;
  }
}

.full-star::after {
  content: " \2605";
  position: absolute;
  top: 50%;
  left: 50%;
  color: white;
  font-size: 10px;
  transform: translate(-50%, -50%);
}
.star-cls .rating-star-total {
  color: #fff !important;
}
.usertest-star {
  justify-content: flex-start !important;
}

.rev-star {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/StarRating.vue